// Session cookie identity, shared by the auth config that writes these cookies
// and the proxy that has to clear them when the session behind one is gone.
// Kept free of "server-only" imports so the proxy can use it in middleware.

export const COOKIE_PREFIX = "SID";

// Mirrors crossSubDomainCookies in auth.config: the bare host, never a port,
// and undefined for a single-label host like plain localhost, where cookies are
// written host-only because a ".localhost" Domain would be discarded.
const rootHost = process.env.BETTER_AUTH_DOMAIN || "localhost";

export const AUTH_COOKIE_DOMAIN = rootHost.includes(".")
    ? `.${rootHost}`
    : undefined;

const SESSION_COOKIE_BASES = [
    `${COOKIE_PREFIX}.session_token`,
    `${COOKIE_PREFIX}.session_data`,
];

// Matches every spelling of the session cookies: better-auth prepends __Secure-
// when secure cookies are on, and splits a cached session too large for one
// cookie into numbered chunks like SID.session_data.0, which a fixed list of
// names would leave behind.
export const isSessionCookieName = (name: string) => {
    const bare = name.startsWith("__Secure-") ? name.slice(9) : name;

    return SESSION_COOKIE_BASES.some(
        (base) => bare === base || bare.startsWith(`${base}.`),
    );
};

// Marks a redirect that happened because a cookie outlived its session row.
// The proxy reads it to stop bouncing the browser back into the app.
export const EXPIRED_SESSION_PARAM = "expired";

// Why the session ended, carried on the login URL so the page can say it out
// loud rather than dropping the user on a blank form with no explanation.
export const SIGNED_OUT_REASON_PARAM = "reason";

export const SIGNED_OUT_REASONS = {
    banned: "Your account has been suspended. Contact support if you believe this is a mistake.",
} as const;

export type SignedOutReason = keyof typeof SIGNED_OUT_REASONS;
